export const ExtraCurricularActions = {
    GET_EXTRACURRICULAR: "GET_EXTRACURRICULAR",
    SET_EXTRACURRICULAR: "SET_EXTRACURRICULAR",
  };